module.exports = __webpack_public_path__ + "static/media/logo.f02b696b.svg";